"use client";

import { buttonVariants } from "@/components/ui/button";
import { IconGoogle } from "@/components/ui/icons";
import { cn } from "@/lib/utils";
import { useI18n } from "@/locales/client";
import { createClient } from "@/utils/supabase/client";

const SignInWithGoogle = ({ redirectTo }: { redirectTo: string | null }) => {
  const t = useI18n();
  const handleClick = async () => {
    try {
      const supabase = createClient();
      const { error } = await supabase.auth.signInWithOAuth({
        provider: "google",
        options: {
          redirectTo: redirectTo
            ? `${location.origin}/auth/callback?next=${redirectTo}`
            : `${location.origin}/auth/callback`,
          queryParams: {
            access_type: "offline",
            prompt: "consent",
          },
        },
      });
      if (error) throw new Error(error.message);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <button
      type="button"
      className={cn(buttonVariants({ variant: "outline" }), "w-full")}
      onClick={handleClick}
    >
      <div className="w-full flex justify-center items-center gap-2">
        <IconGoogle />
        <span className="">{t("auth.continueWithGoogle")}</span>
      </div>
    </button>
  );
};

export default SignInWithGoogle;
